import React from 'react';
import CategoriesFilter from 'components/list/Filters/types/CategoriesFilter';

const CategoryIdFilter = <CategoriesFilter
    label='filters.components.categoryId.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='category_id'
/>;

export default CategoryIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/CategoryIdFilter.js